import React from "react";

import mainImage from "../../../../assets/HomePage/FlagshipAccessImg.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Paper, Typography, Grid } from "@mui/material";

const Mastermind = () => {
  return (
    <Paper
      elevation={20}
      sx={{ padding: { xs: "2rem", md: "4rem" }, mt: "6rem", borderRadius: 5 }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          color: "secondary.main",
          mb: "1rem",
        }}
      >
        YOUR MASTERMIND
      </Typography>
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: "bold",
          maxWidth: { xs: "100%", sm: "70%" },
          textAlign: "center",
          mx: "auto",
        }}
      >
        Why should you join a mastermind?
      </Typography>
      <Typography variant="body1" sx={{ mt: "1.2rem", textAlign: "center" }}>
        Being part of a mastermind group is one of the most effective ways to
        help you move forward in your business.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1.2rem", textAlign: "center" }}>
        You will be{" "}
        <b>
          matched into a hyper-curated peer group consisting of 6 SaaS Founders
          at a similar stage.
        </b>{" "}
        Every month, this group of SaaS Founders will meet, and work through
        their individual business problems using our framework, with support
        from an experienced facilitator.
      </Typography>
      <Grid
        container
        spacing={6}
        sx={{ my: "3rem", textAlign: "center" }}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item lg={6}>
          <img
            src={mainImage}
            alt="mastermindImage"
            style={{ width: "100%", height: "auto" }}
          />
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: "bold", mt: "3rem" }}
            >
              A core peer-advisory group
            </Typography>
            <List sx={{ maxWidth: { xs: "100%", sm: "100%" } }}>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Your group members understand your challenges. They've been there,
            done that and want to help you."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="They brainstorm solutions to your biggest problems." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="They give you honest feedback so you can be true to your business." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText
                  primary="They keep you accountable to your goals so you're always moving
            forward."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="They are a sounding board for your struggles." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="They help you get your priorities in order." />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Mastermind;
